import FormattedMessage from 'I18n/components/FormattedMessage';
import { MoveableObject } from 'foundations-components/transitional/components/MoveableObject';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCallback, useMemo } from 'react';
import { isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import useFetchPropertyMetaDataForDataType from 'reporting-data/hooks/useFetchPropertyMetaDataForDataType';
import { getDataType, getDisplayParamsDataColumns } from 'reporting-data/report/configReportGetters';
import { getPropertiesFromConfigReportForDataColumnsModal, isUEQLSearchConfig } from './utils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SelectedPropertiesPanel = ({
  report,
  onChange
}) => {
  const dataColumns = useMemo(() => {
    return getDisplayParamsDataColumns(report) || [];
  }, [report]);
  const propertiesInOriginalReport = getPropertiesFromConfigReportForDataColumnsModal(report);
  const propertyMetadataFetch = useFetchPropertyMetaDataForDataType(getDataType(report));
  const reportIsUEQLSearchConfig = useMemo(() => isUEQLSearchConfig(report), [report]);
  const onRemoveProperty = useCallback(property => () => {
    const index = dataColumns.indexOf(property);
    const updatedReport = report.deleteIn(['displayParams', 'dataColumns', index]);
    if (reportIsUEQLSearchConfig) {
      const metricIndex = updatedReport.getIn(['config', 'metrics']).findIndex(metric => metric.get('property') === property);
      onChange(updatedReport.deleteIn(['config', 'metrics', metricIndex]));
    } else {
      onChange(updatedReport);
    }
  }, [dataColumns, onChange, report, reportIsUEQLSearchConfig]);
  if (isLoading(propertyMetadataFetch)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "properties-loading",
      layout: "centered"
    });
  } else if (isSucceeded(propertyMetadataFetch)) {
    const propertyMetadata = propertyMetadataFetch.data;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: dataColumns.map(property => {
        return /*#__PURE__*/_jsx(Tooltip, {
          disabled: reportIsUEQLSearchConfig || !propertiesInOriginalReport.includes(property),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "report-customization-components.customization-components.data-columns-modal.config.disabledProperty"
          }),
          placement: "top",
          children: /*#__PURE__*/_jsx(MoveableObject, {
            onClose: onRemoveProperty(property),
            isCloseDisabled: !reportIsUEQLSearchConfig && propertiesInOriginalReport.includes(property),
            draggable: false,
            children: /*#__PURE__*/_jsx("p", {
              children: propertyMetadata.getIn([property, 'label'])
            })
          })
        }, property);
      })
    });
  }
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.data-columns-modal.config.error"
    })
  });
};
export default SelectedPropertiesPanel;